var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('p',{staticClass:"small",staticStyle:{"margin-top":"80px","margin-bottom":"50px","opacity":"0.5"}},[_vm._v("Whoops! Page not found.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }